module.exports = __webpack_public_path__ + "img/emailFail.1c9895a1.png";